<template>
    <div>
        <div class="col-12 pt-1 row g-0">
            <div class="form-group col-12">
                <label for="primary-physician">{{
                    physicianIndex == 0 ? "Primary Physician" : "Additional Physician"
                }}</label>
                <TypeaheadInput
                    placeholder="Start Typing"
                    :getData="getPhysicianList"
                    :value="physicians"
                    v-on:valueChanged="changePhysician"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./CreatePhysicianRow.ts"></script>
